const subjectDict = {
    'far': 'Financial Accounting & Reporting',
    'aud': 'Auditing & Attestation', 
    'reg': 'Taxation and Regulation', 
    'bar': 'Business Analysis and Reporting', 
    'isc': 'Information Systems and Controls', 
    'tcp': 'Tax Compliance and Planning', 
    'bec': 'Business Environment & Concepts'
}
const xtypeDict = {
    'mcq': 'MCQ單選題',
    'sim': 'Simulation情境模擬試題', 
    'moc': 'Simulated Exam全真模擬試題'
}
const subject2Dict = {
    'p1': 'Part 1',
    'p2': 'Part 2', 
}
const xtype2Dict = {
    'mcq': 'MCQ單選題',
    'essay': 'Essay 寫作題'
}

const userTypeList = ['CPA', 'CMA'];
const replyStatusList = ['尚未回覆', '已回覆', '拒絕'];
const chapterList = ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8']
const sim_setList = ['SIM1', 'SIM2'];
const moc_setList = ['exam1', 'exam2'];
const testletList = ['testlet1', 'testlet2', 'testlet3', 'testlet4', 'testlet5'];

module.exports = {
    subjectDict,
    xtypeDict,
    subject2Dict,
    xtype2Dict,
    userTypeList,
    replyStatusList,
    chapterList,
    sim_setList,
    moc_setList,
    testletList,
}